AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "Problem");

AoPS.Ebooks.Models.Problem = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var EbkMBase = AoPS.Ebooks.Models.Base;

	return EbkMBase.BaseModel.extend({
		id_attribute: "problem_id",
		defaults: {
			number: "",
			has_soln_perms: false,
			has_submitted: false,
			submission_before: "",
			submission_before_html: "",
			submission_after: "",
			submission_after_html: "",
			solution_html: "",
		},
		/** Additional attributes:
			book: Book model owning this one; guaranteed to be set
		*/

		submitProblem: function (submission, is_final, callback, context) {
			function onSubmit(ok, data) {
				if (!ok) {
					return callback(ok, data);
				}
				this.unpack(data.response.problem);
				callback(ok, data.response.problem);
			}

			submission = _.isString(submission) && submission.trim();
			if (!submission && submission !== "") {
				return;
			}
			callback = LoadUtils.makeCallback(callback, context);

			var book = this.get("book");
			EbkMBase.ajax.run(
				"save_problem",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					problem_id: this.id,
					submission: submission,
					is_final: is_final ? 1 : 0,
				},
				_.bind(onSubmit, this)
			);
		},

		resetProblem: function (callback, context) {
			function onSubmit(ok, data) {
				if (!ok) {
					return callback(ok, data);
				}

				this.set({
					has_submitted: false,
					submission_before: "",
					submission_before_html: "",
					submission_after: "",
					submission_after_html: "",
					solution_html: "",
				});
				this.unpack(data.response.problem);
				callback(ok, data.response.problem);
			}

			callback = LoadUtils.makeCallback(callback, context);

			var book = this.get("book");
			EbkMBase.ajax.run(
				"reset_problem",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					problem_id: this.id,
				},
				_.bind(onSubmit, this)
			);
		},

		// Used in book preview
		resetProblemLocal: function (callback, context) {
			function onSubmit() {
				this.set({
					has_submitted: false,
					submission_before: "",
					submission_after: "",
					solution_html: "",
				});
				callback(true);
			}

			callback = LoadUtils.makeCallback(callback, context);

			setTimeout(_.bind(onSubmit, this), 0);
		},

		viewPreviewSolution: function (submission, callback, context) {
			var book = this.get("book");
			if (book.get("has_access")) {
				return this.submitProblem(submission, true, callback, context);
			}

			function onSubmit(ok, data) {
				if (!ok) {
					return callback(ok, data);
				}
				this.unpack(data.response.problem);
				this.set("submission_before", submission);
				this.set("has_submitted", true);
				this.set("has_soln_perms", true);
				callback(ok, data.response.problem);
			}
			callback = LoadUtils.makeCallback(callback, context);

			EbkMBase.ajax.run(
				"view_preview_solution",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					problem_id: this.id,
				},
				_.bind(onSubmit, this)
			);
		},
	});
})();
